import { FC } from 'react';
import { logEvent } from '@/analytics';
import { Text } from '@mofid-securities/uikit';
import { useAPI } from '@/services/utils';
import BottomSheet from '@/components/BottomSheet';
import Button from '@/components/Button';
import Toast from '@/components/Toast';

export const ConsultationRequestBottomSheet: FC = () => {
  const { mutateAsync, isLoading } = useAPI(['fund', 'requestConsultation'], {
    isMutation: true,
  });

  const handleRequestConsultationClick = async () => {
    logEvent('FUNDS_CONSULTANT_CONFIRM');
    try {
      await mutateAsync(null);
      BottomSheet.close();
      Toast.open({
        variant: 'success',
        children: 'درخواست مشاوره ارسال شد.',
      });
    } catch (error: any) {
      BottomSheet.close();
      Toast.open({
        variant: 'error',
        children: error?.message || 'خطا در ثبت درخواست مشاوره',
      });
    }
  };

  return (
    <div className="flex flex-col gap-y-6">
      <Text color="gray-120" size="sm" weight="regular">
        با ثبت درخواست، مشاوران سرمایه گذاری مفید حداکثر تا ۲ روز کاری آینده بین
        ساعت ۹ صبح تا ۶ عصر با شما تماس خواهند گرفت و ضمن پاسخگویی به پرسش‌های
        شما، کمک می‌کنند صندوق سرمایه‌گذاری مناسب خود را انتخاب کنید.
      </Text>
      <Button
        id="funds_submit_consultant"
        isLoading={isLoading}
        isFullWidth
        onClick={handleRequestConsultationClick}
      >
        ثبت درخواست مشاوره
      </Button>
    </div>
  );
};
